import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "core-js/stable";
import "regenerator-runtime/runtime";

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import "vuetify/dist/vuetify.min.css";

import Vuetify from "vuetify";
Vue.use(Vuetify);

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.use(require('vue-jalali-moment'));

Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    inputFormat: 'YYYY-MM-DD',
    format: 'jYYYY-jMM-jDD',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: '',
    altFormat: 'YYYY-MM-DD',
    color: '#f9dc63',
    autoSubmit: true
  }
});

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
Vue.use(VueSlickCarousel )

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

Vue.config.productionTip = false;

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "";
  });
});

new Vue({
  router,
  render: (h) => h(App),
  vuetify: new Vuetify(),
}).$mount("#app");
